import React, { memo } from "react";
import WithStyles from "shared/components/WithStyles";
import { getAkamaiUrl } from "shared/helpers/utils";

import { chunkStyles } from "./styles";

function ChunkFallback() {
    return (
        <WithStyles cssProps={chunkStyles}>
            <div className="blobs">
                <div className="blob-center">
                    <img
                        src={getAkamaiUrl(
                            "/pub/static/frontend/Nykaa/theme001/en_US/Fermion_CustomCheckout/images/N.svg"
                        )}
                        alt="Nykaa Loader"
                        className="blog-image"
                    />
                </div>
                <div className="blob" />
                <div className="blob" />
                <div className="blob" />
                <div className="blob" />
                <div className="blob" />
                <div className="blob" />
            </div>
        </WithStyles>
    );
}

export default memo(ChunkFallback, () => true);
